export function formatNumber(value) {
  return Intl.NumberFormat().format(value);
}

export function generateRandomString(length) {
  var randomString = "";
  var chars = "ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz123456789";
  for (var i = 0; i < length; i++) {
    randomString += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return randomString;
}

export function round(value, decimals) {
  return Number(Math.ceil(value + "e" + decimals) + "e-" + decimals);
}
